var _effectorFileName = "/builds/gmini/front-ui-kit/src/LinearProgress/LinearProgress.tsx";
import { LinearShrinkBar, LinearProgressWrapper, LinearExpandBar } from './LinearProgress.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LinearProgress = ({
  color = 'primary',
  ...other
}) => /*#__PURE__*/_jsxs(LinearProgressWrapper, {
  color: color,
  ...other,
  children: [/*#__PURE__*/_jsx(LinearExpandBar, {}), /*#__PURE__*/_jsx(LinearShrinkBar, {})]
});